import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

import { numberWithCommas } from '../../../utils/strings'

import style from '../style'

export const DailySummary = props => {
  return [
    <h3 key={0} className={css(style.headers.h3)}>
      Today's Statistics
    </h3>,
    <Row
      key={1}
      className={`
      d-flex flex-column align-items-center justify-content-center
      ${css(
        style.daily.box,
        style[props.theme.name] ? style[props.theme.name].daily.box : null
      )}
    `}
    >
      <Col
        xs='12'
        className={`d-flex justify-content-between ${css(
          style.daily.row,
          style[props.theme.name] ? style[props.theme.name].daily.row : null
        )}`}
      >
        <span
          className={css(
            style.daily.label,
            style[props.theme.name] ? style[props.theme.name].daily.label : null
          )}
        >
          Requests
        </span>
        <span className={css(style.daily.value)}>
          {numberWithCommas(props.stats.queries)}
        </span>
      </Col>
      <Col
        xs='12'
        className={`d-flex justify-content-between ${css(
          style.daily.row,
          style[props.theme.name] ? style[props.theme.name].daily.row : null
        )}`}
      >
        <span
          className={css(
            style.daily.label,
            style[props.theme.name] ? style[props.theme.name].daily.label : null
          )}
        >
          Impressions
        </span>
        <span className={css(style.daily.value)}>
          {numberWithCommas(props.stats.impressions)}
        </span>
      </Col>
      <Col
        xs='12'
        className={`d-flex justify-content-between ${css(
          style.daily.row,
          style[props.theme.name] ? style[props.theme.name].daily.row : null
        )}`}
      >
        <span
          className={css(
            style.daily.label,
            style[props.theme.name] ? style[props.theme.name].daily.label : null
          )}
        >
          Earnings
        </span>
        <span className={css(style.daily.value)}>
          ${props.stats.earnings.toFixed(2)}
        </span>
      </Col>
    </Row>
  ]
}

DailySummary.propTypes = {
  stats: PropTypes.object.isRequired
}

export default DailySummary



// WEBPACK FOOTER //
// ./src/components/Statistics/partials/DailySummary.js